import { AbstractFacade } from '@goparrot/common';
import deepmerge from 'deepmerge';
export class SquareConnectSSOFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_GATEWAY,
            },
        }, config), interceptors);
    }
    async redirect() {
        return (await this.client.get('api/v1/square/connect/sso')).data;
    }
    async callback(code, state) {
        await this.client.post(`api/v1/square/connect/sso`, undefined, { params: { code, state } });
    }
}
//# sourceMappingURL=SquareConnectSSOFacade.js.map